<template>
  <div class="register">
    <div class="rform">
      <h3>忘记密码</h3>
      <van-form @submit="handleSubmit" class="formWrap">
        <!-- 用户名  :name="$t('register.uname')"-->
        <van-field v-model="formValues.uname" type="uname" name="uname" :label="$t('register.uname')"
          :placeholder="$t('register.uname')" />
        <!-- 名称 -->
        <van-field v-model="formValues.name" type="name" name="name" :label="$t('register.name')"
          :placeholder="$t('register.name')" />
        <!-- 手机号   :name="$t('register.phone')" -->
        <van-field v-model="formValues.phone" type="number" name="phone" :label="$t('register.phone')"
          :placeholder="$t('register.phone')" />
        <!-- 验证码  :name="$t('register.verification_code')"-->

        <van-field v-model="formValues.code" type="number" name="code" :label="$t('register.verification_code')"
          :placeholder="$t('register.verification_code')">
          <template #button>
            <van-button class="send_code" size="small" type="primary" v-show="!timeLoading" @click="handleSendCode"
              native-type="button">
              {{ sendCodeText }}
            </van-button>
            <van-button v-show="timeLoading">
              <van-loading />
            </van-button>
          </template>
        </van-field>
        <!-- 密码 :name="$t('register.upwd')"-->
        <van-field v-model="formValues.upwd" type="password" name="upwd" :label="$t('register.upwd')"
          :placeholder="$t('register.upwd')" />

        <!-- 确认密码 -->
        <van-field v-model="formValues.rpwd" type="password" name="rpwd" label="确认密码" placeholder="请再次输入密码" />

        <div class="back" @click="handleGoBack">
          <span>{{ $t('register.msg_back') }}</span>
        </div>
        <div>
          <van-button class="submit" round block type="info" native-type="submit">
            确认重置
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
const reg = /^1[3|4|5|7|8][0-9]{9}$/
let timerCount = 60
export default {
  data () {
    return {
      formValues: {
        uname: '', // 用户名
        name: '', // 组织名称
        phone: '', // 手机号
        code: '', // 验证码
        upwd: '', // 密码
      },
      timeLoading: false,
      timer: null,
      sendCodeText: this.$t('register.send_code'), // 发送验证码按钮的文案
    }
  },
  methods: {
    // 获取验证码
    handleSendCode () {
      if (this.timer) return
      // 校验用户名 名称 手机号
      const { phone, uname, name } = this.formValues
      // 此对象的顺序不能变，因为要顺序校验
      const phoneNeedParam = {
        uname,
        name,
        phone,
      }
      const state = this.checkValues(phoneNeedParam)
      if (!state) {
        // 假设发送手机短信成功
        // 开启倒计时 timer loading 修改倒计时文案
        this.timeLoading = true

        setTimeout(() => {
          this.timeLoading = false
          this.openTimer()
        }, 2000)

        // 发送请求 发送手机短信
        this.$api
          .sendPhoneCode({
            phoneNo: phone,
            loginName: uname,
            realName: name,
          })
          .then((res) => {
            console.log('发送手机验证码：', res)
            this.$toast(res.errmsg)
          })
          .catch((err) => {
            console.log('sendPhoneMsg:', err)
            this.$toast(err.errmsg)
          })
      }
    },

    /**
     * @desc 校验是否符合11位手机号要求
     * @param {String}
     * @return {Boolean}
     */
    checkPhone (phone) {
      if (reg.test(phone)) {
        this.$toast(this.$t(`register.msg_phone_vaild}`))
        return false
      }
    },

    /**
     * @desc 公用方法，校验传进来的 data 中的属性值不能为空置 且手机号符合要求
     * @param {Object}
     * @return {Boolean}
     */
    checkValues (data) {
      let valid = false
      for (const key in data) {
        // 不能为空置
        if (this.$isblank(data[key])) {
          valid = true
          return this.$toast(this.$t(`register.msg_${key}`))
        }

        // 个别项长度限制   phone 11 位
        if (key === 'phone') {
          if (data[key]?.length != 11) {
            valid = true
            return this.$toast(this.$t(`register.msg_phone_vaild`))
          }
        }

        // 个别项长度限制   密码最少 6 位
        if (key === 'upwd') {
          console.log('key')

          if (data[key].length < 6) {
            valid = true
            return this.$toast(this.$t(`register.msg_${key}`))
          }
        }

        // 校验再次输入的密码和前面的密码是否一致
        if (key === 'rpwd') {
          if (this.formValues.upwd !== this.formValues.rpwd) {
            valid = true
            return this.$toast('两次输入的密码不一致')
          }
        }
      }

      return valid
    },

    // 开启倒计时
    openTimer () {
      this.sendCodeText = `${timerCount}s`
      this.timer = setInterval(() => {
        timerCount >= 0 && timerCount--
        this.sendCodeText = `${timerCount}s`
        if (timerCount < 0) {
          this.sendCodeText = this.$t('register.send_code')
          clearInterval(this.timer)
          this.timer = null
          timerCount = 60
        }
      }, 1000)
    },

    //   提交
    handleSubmit (values) {
      // 校验每项
      const { phone, name, uname, upwd, code } = values
      if (!this.checkValues(values)) {
        console.log('通过校验')
        // 通过校验 请求注册
        this.$api
          .reSetPWD({
            phoneNum: phone,
            phoneCode: code,
            newPassword: this.$md5(upwd),
          })
          .then((res) => {
            if (res.errcode === 0) {
              // 注册成功后 回到 /login
              this.$toast({
                type: 'success',
                message: '重置成功',
                forbidClick: true,
                onClose: () => {
                  this.$router.replace('/login')
                },
              })
            } else {
              this.$toast(res.errmsg)
            }
          })
          .catch((err) => {
            console.error('注册接口 handleSubmit:', err)
            this.$toast(err.errmsg)
          })
      }
    },

    // 回到登录页面
    handleGoBack () {
      this.$router.back(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
h3 {
  font-family: MI Lan Pro VF;
  font-weight: 500;
  line-height: 30px;
  color: #000000;
  margin-bottom: 26px;
}

.register {
  padding: 0.77rem 0 0.88rem;
  margin-top: 15px;

  .rform {
    position: relative;
    width: 6rem;
    margin: 0 auto;
    padding: 0 0.2rem;
  }

  /deep/.van-cell {
    border: 1px solid rgba(53, 105, 233, 0.9);
    border-radius: 8px;
    margin-bottom: 16px;

    .van-field__label {
      margin-right: 0;
    }
  }

  .send_code {
    position: absolute;
    top: 0;
    right: -10px;
    height: 24px;
    box-sizing: border-box;
    background: #ffffff;
    color: #4877ea;
    border: 0;
  }

  // 注册
  .submit {
    // position: absolute;
    // bottom: 4rem;
    width: 6rem;
    height: 48px;
    line-height: 48px;
    background: linear-gradient(90deg, #4877ea 0%, #3769df 100%);
    text-align: center;
    color: #fff;
    margin: 0rem auto 0;
    font-size: 16px;
    box-shadow: 0 0.05rem 0.1rem #827d88;
    border-radius: 0;
    border: 0 !important;
    margin-top: 10px;
  }

  // 回登录
  .back {
    font-size: 0.3rem;
    color: rgba(53, 105, 233, 0.9);
    margin-top: 0.3rem;
  }
}
</style>
